<template>
  <div>
    <div
      v-for="(item, index) in machine_template_list"
      :key="index"
      class="machine-item"
      @click="machine_template_selected(item)"
    >
      <div class="d-flex px-4 py-3">
        <p style="margin-bottom: 0px">
          {{ item.machine_template_name }}
        </p>
      </div>
      <div class="px-2">
        <v-divider></v-divider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    machine_template_list: Array,
  },
  data: function () {
    return {};
  },
  methods: {
    machine_template_selected(selected_template) {
      this.$emit("machine_template_selected", selected_template);
    },
  },
};
</script>

<style scoped>
.machine-item {
  cursor: pointer;
}

.machine-item:hover {
  background: rgba(255, 0, 0, 0.15);
}
</style>